import asyncComponent from '../../app/AsyncComponent/AsyncComponent';
export {default as icon} from './icon';
export {default as label} from './label';
export {default as page} from './page';
export {default as route} from './route';

export default asyncComponent(() => import('./GasPage'));
